import { getData } from "./base.service";

export interface SettlementIdentity {
    village_name: string;
    district: string;
    council: string;
    coordinates: {
        latitude: number;
        longitude: number;
    };
}

export interface BasicScale {
    total_households: number | null;
    estimated_population: number | null;
    distance_to_grid_km: number | null;
    template_type: string | null;
}

export interface NesPlanningClassification {
    recommended_electrification_approach: string | null;
    nes_tag: string | null;
    display_label: string | null;
}

export interface PublicAndEconomicProfile {
    public_facilities: string[];
    marketplaces_count: number | null;
    average_traders_per_market: number | null;
    main_livelihood_activities: string[];
    main_productive_use_activities: string[];
    main_commercial_activities: string[];
}

export interface AccessAndReadinessSummary {
    existing_electricity_infrastructure: string | null;
    mobile_money_available: string[];
    readiness_notes: string[];
}

export interface StorytellingFields {
    headline_tag: string | null;
    short_description: string | null;
    why_this_village_matters: string | null;
    photo: string | null;
}

export interface SettlementProfileRow {
    id: number;
    village_name: string;
    district: string | null;
    council: string | null;
    latitude: number | null;
    longitude: number | null;
    total_households: number | null;
    estimated_population: number | null;
    distance_to_grid_km: number | null;
    template_type: string | null;
    recommended_electrification_approach: string | null;
    nes_tag: string | null;
    display_label: string | null;
    public_facilities: string[];
    marketplaces_count: number | null;
    average_traders_per_market: number | null;
    main_livelihood_activities: string[];
    main_productive_use_activities: string[];
    main_commercial_activities: string[];
    existing_electricity_infrastructure: string | null;
    mobile_money_available: string[];
    readiness_notes: string[];
    headline_tag: string | null;
    short_description: string | null;
    why_this_village_matters: string | null;
    photo: string | null;
    created_at: Date;
    updated_at: Date;
}

export interface SettlementDto {
    id: number;
    settlement_identity: SettlementIdentity;
    basic_scale: BasicScale;
    nes_planning_classification: NesPlanningClassification;
    public_and_economic_profile: PublicAndEconomicProfile;
    access_and_readiness_summary: AccessAndReadinessSummary;
    storytelling_fields: StorytellingFields;
    created_at: Date;
    updated_at: Date;
}

export function getAllSurveySettlements(): Promise<SettlementDto[]> {
    return getData('/survey/settlements');
}

export function getSurveySettlementsByDistrict(district: string): Promise<SettlementDto[]> {
    return getData(`/survey/settlements/district/${encodeURIComponent(district)}`);
}

export function getSurveySettlementById(id: number): Promise<SettlementDto> {
    return getData(`/survey/settlements/${id}`);
}
